import * as React from "react";
import { classNames } from "src/common/classNames";
import {
  PropsReactiveTable,
  ReactiveTable,
} from "src/components/ReactiveTable/components/ReactiveTable";
import {
  AbstractFilters,
  AbstractRow,
} from "src/components/ReactiveTable/RtTypes";

import * as styles from "./MdmTable.module.less";

export type PropsMdmTable<
  TRow extends AbstractRow,
  TFilters extends AbstractFilters,
> = PropsReactiveTable<TRow, TFilters>;

/**
 * Основной компонент таблицы для использования в MDM-интерфейсе.
 * Используйте `MdmTable` вместо устаревшего `CustomReactiveTable`.
 * Добавлен в рамках задачи MDM2-1010.
 */
export const MdmTable = <
  TRow extends AbstractRow,
  TFilters extends AbstractFilters,
>({
  className,
  ...props
}: PropsMdmTable<TRow, TFilters>) => (
  <ReactiveTable {...props} className={classNames([styles.theme, className])} />
);
